import { Tags } from "@/enum/tags";
import { toQueryParams } from "@/utils/to-query-params";
import { apiSlice } from "./http";

const RESOURCE_URL: string = "/conciliation-audit";

export interface AuditTrailParams {
  actor_email?: string;
  action?: string;
  entity_name?: string;
  entity_id?: string;
  start?: string;
  end?: string;
  page: number;
  perPage: number;
}

export interface AuditTrailEntryResponse {
  id: number;
  changed_at: string;
  changed_by: string;
  action: string;
  entity_name: string | null;
  entity_type: string;
  entity_id: string;
  ip: string | null;
  description: string;
}

export interface AuditTrailMeta {
  total: number;
  currentPage: number;
  lastPage: number;
  perPage: number;
}

export interface AuditTrailPage {
  data: AuditTrailEntryResponse[];
  meta: AuditTrailMeta;
}

export const conciliationAuditApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAuditTrail: builder.query<AuditTrailPage, AuditTrailParams>({
      query: (filters) => ({
        url: `${RESOURCE_URL}?${toQueryParams(filters)}`,
        method: "GET",
      }),
      providesTags: [Tags.AUDIT_TRAIL],
    }),
  }),
});

export const { useGetAuditTrailQuery } = conciliationAuditApi;
